import React, {Component} from "react";
import {Grid, Header, Form, Segment, Dimmer, Loader, Button, Message} from "semantic-ui-react";

export interface ILoginProps{
    onLogin:    () => void
}

export interface ILoginState{
    loader:     boolean
    message:    string,
    login:      string
    pass:       string
}

class Login extends Component<ILoginProps, ILoginState> {
    state: ILoginState = {
        loader: false,
        message: "",
        login: "",
        pass: ""
    };

    render() {
        return(
            <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 450 }}>
                    <Header as='h2' color='blue' textAlign='center'>
                        Please login
                    </Header>
                    <Form size='large'>
                        <Segment stacked>
                            <Dimmer inverted active={this.state.loader}>
                                <Loader />
                            </Dimmer>
                            <Form.Input
                                fluid
                                icon='user'
                                iconPosition='left'
                                placeholder='Login'
                                value={this.state.login}
                                onChange={(_, {value}) => this.setState({login: value})}
                            />
                            <Form.Input
                                fluid
                                icon='lock'
                                iconPosition='left'
                                placeholder='Password'
                                type='password'
                                value={this.state.pass}
                                onChange={(_, {value}) => this.setState({pass: value})}
                            />
                            <Message negative hidden={!this.state.message} style={{textAlign:'left'}}>
                                {this.state.message}
                            </Message>

                            <Button
                                color='blue'
                                size='large'
                                fluid
                                basic
                                disabled={!this.state.login || !this.state.pass}
                                onClick={_ => {
                                    this.setState({loader: true});
                                    fetch('/auth', {
                                        headers: {
                                            login: this.state.login,
                                            pass: this.state.pass
                                        }
                                    })
                                        .then(result => result.text()
                                            .then(text => result.ok ? this.props.onLogin && this.props.onLogin() : this.setState({message: text, loader:false}))
                                            .catch(error => this.setState({message: error.toString(), loader:false})))
                                        .catch(error => this.setState({message: error.toString(), loader:false}))
                                }}
                            >
                                Login
                            </Button>
                        </Segment>
                    </Form>
                </Grid.Column>
            </Grid>
        )
    }
}

export default Login;